import { CompoundProductionStepAssignmentDto } from '@services/dtos'
import { useEffect } from 'react'
import BaseConfigTable from './BaseConfigTable'
import { useAppDispatch } from '@hooks/reduxHooks'
import { AppDispatch } from '@state/store'
import {
  getCompoundProductionStepAssignments,
  removeCompoundProductionStepAssignment,
  setCompoundProductionStepAssignmentFilters,
  updateCompoundProductionStepAssignment,
} from '@state/reducers/compoundProductionStepAssignmentReducer'
import CompoundProductionStepAssignmentForm from '../forms/CompoundProductionStepAssignmentForm'
import { compoundProductionStepAssignmentColumns } from '@utils/gridColumns'

export default function CompoundProductionStepAssignmentsTable() {
  const dispatch = useAppDispatch()
  useEffect(() => {
    return () => {
      dispatch(
        setCompoundProductionStepAssignmentFilters({ includeInactive: false }),
      )
    }
  }, [])

  return (
    <BaseConfigTable<CompoundProductionStepAssignmentDto>
      columns={compoundProductionStepAssignmentColumns}
      selectRows={(state) => state.compoundProductionStepAssignment.items}
      fetchThunk={() => async (dispatch: AppDispatch) => {
        dispatch(
          setCompoundProductionStepAssignmentFilters({ includeInactive: true }),
        )
        return dispatch(getCompoundProductionStepAssignments())
      }}
      deleteThunk={removeCompoundProductionStepAssignment}
      toggleThunk={(id, isActive) =>
        updateCompoundProductionStepAssignment({ id, dto: { isActive } })
      }
      updatePageThunk={(page) => async (dispatch: AppDispatch) => {
        dispatch(setCompoundProductionStepAssignmentFilters({ page }))
        dispatch(getCompoundProductionStepAssignments())
      }}
      FormComponent={({ editingItem, onClose }) => (
        <CompoundProductionStepAssignmentForm
          editingCompoundProductionStepAssignment={editingItem}
          onClose={onClose}
        />
      )}
      resourceLabel="affectation d'étapes de production"
      resourcePrefix="l'"
      formMaxWidth="xl"
    />
  )
}
